import $ from 'jquery';

const SELECTOR = '.tabbed-content';
const TAB_SELECTOR = '.tabs .wp-block-button__link';

function onDocumentReady() {
	$(SELECTOR).each(initializeElement);
}

function initializeElement(i, el) {
	const $el = $(el);
	$el.on('click', TAB_SELECTOR, onClickTab);

	if($(SELECTOR).hasClass('service-tabs')) {
		return;
	}

	setActiveTab($el, $el.find(TAB_SELECTOR).eq(0));
}

function onClickTab(e) {
	const $clicked = $(e.currentTarget);
	const $el = $clicked.closest(SELECTOR);
	setActiveTab($el, $clicked);

	e.stopPropagation();
	return false;
}

function setActiveTab($el, $tab) {
	$el.find(`${TAB_SELECTOR}.active`).removeClass('active');
	$el.find('.wp-block-group:not(.tabs):not(.tabbed-content-container').each((i, group) => {
		const $group = $(group);

		if (`#${$group.attr('id')}` === $tab.attr('href')) {
			if($group.hasClass('active')) {
				$tab.removeClass('active');
				$group.removeClass('active').slideUp(200);
				$group.attr('aria-hidden', true).attr('aria-expanded', false);
			} else {
				$tab.addClass('active');
				$group.addClass('active').stop(true, false).slideDown(200);
				$group.attr('aria-hidden', false).attr('aria-expanded', true);
			}
		} else {
			$group.removeClass('active').slideUp(200);
			$group.attr('aria-hidden', true).attr('aria-expanded', false);
		}
	});
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
